/**
 * Theme JS — Global utilities for Floodgate Games v2
 */
(function() {
  'use strict';

  // --- AJAX Cart: shared add-to-cart handler ---
  window.theme = window.theme || {};

  theme.cart = {
    addItem: function(variantId, quantity) {
      quantity = quantity || 1;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: quantity })
      }).then(function(r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      }).then(function(item) {
        theme.cart.updateBadge();
        return item;
      });
    },

    updateBadge: function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var countEl = document.querySelector('[data-cart-count]');
          var bubble = document.querySelector('[data-cart-count-bubble]');
          if (countEl) countEl.textContent = cart.item_count;
          if (bubble) {
            if (cart.item_count > 0) bubble.classList.remove('hide');
            else bubble.classList.add('hide');
          }
        });
    },

    getCart: function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    }
  };

  // --- Cart Popup (slide-in panel) ---
  var cartPopup = document.querySelector('.cart-popup');
  var cartOverlay = document.querySelector('.cart-popup__overlay');

  theme.cart.openPopup = function() {
    if (cartPopup) cartPopup.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  };

  theme.cart.closePopup = function() {
    if (cartPopup) cartPopup.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (cartOverlay) {
    cartOverlay.addEventListener('click', theme.cart.closePopup);
  }
  var cartCloseBtn = cartPopup ? cartPopup.querySelector('[data-cart-popup-close]') : null;
  if (cartCloseBtn) {
    cartCloseBtn.addEventListener('click', theme.cart.closePopup);
  }

  // --- Prelaunch Popup (session-based) ---
  var prelaunchPopup = document.querySelector('.prelaunch-popup');
  if (prelaunchPopup) {
    var popupKey = 'prelaunch_popup_shown';
    if (!sessionStorage.getItem(popupKey)) {
      setTimeout(function() {
        prelaunchPopup.classList.add('is-active');
        sessionStorage.setItem(popupKey, '1');
      }, 1500);
    }

    var closePrelaunch = prelaunchPopup.querySelector('[data-prelaunch-close]');
    var prelaunchOverlay = prelaunchPopup.querySelector('.prelaunch-popup__overlay');
    if (closePrelaunch) closePrelaunch.addEventListener('click', function() { prelaunchPopup.classList.remove('is-active'); });
    if (prelaunchOverlay) prelaunchOverlay.addEventListener('click', function() { prelaunchPopup.classList.remove('is-active'); });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && prelaunchPopup.classList.contains('is-active')) {
        prelaunchPopup.classList.remove('is-active');
      }
    });
  }

  // --- Money formatting utility ---
  theme.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || theme.moneyFormat || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }

    switch (format.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    }

    return format.replace(placeholderRegex, value);
  };

})();
